import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LoadingGkComponent } from '@shared/components/loading/loading.component';

@Component({
	selector: 'app-public-layout',
	imports: [RouterOutlet, LoadingGkComponent],
	templateUrl: './public-layout.component.html',
	styleUrl: './public-layout.component.scss',
})
export class PublicLayoutComponent {}
